import { all, call, fork, put, select, takeEvery } from "@redux-saga/core/effects";
import { GET_MISSING, ON_ADD_Missing } from "../../constants/ActionTypes";
import { getData, postData } from "../../util/DynamicApi";
import { ShowSmallError, ShowSuccess, TimerClsoe } from "../../util/MessageHelper";
import {
    AddMissionSuccess,
    getMissingSuccess,
    showMissionMessage, hideMissionLoader
} from "../actions";

export const getToken = ({ auth }) => auth.token;

const getMissingRequest = async (token, pageIndex, searchText,justFind) =>
    await getData(token, "AdvertisingMissing/GetMissing", {

        pageIndex: pageIndex,
        searchText: searchText,
        justFind: justFind

    }).then((missing) => {
        return missing;
    })
        .catch((error) => {
            return error.response.data;;
        });



function* doGetMissing({ payload }) {
    let { pageIndex, searchText ,justFind} = payload;
    try {
        let token = yield select(getToken);
        const missing = yield call(getMissingRequest, token, pageIndex, searchText,justFind);
        if (missing.errorMessage) {
            ShowSmallError(missing.errorMessage);
            yield put(hideMissionLoader());
        } else {
            yield put(getMissingSuccess(missing.data));

        }
    } catch (error) {
        yield ShowSmallError(error);
    }
}

export function* getMissingUser() {
    yield takeEvery(GET_MISSING, doGetMissing);
}
const addMissingRequest = async (token, data) =>
    await postData(token, "advertising-missing",data.payload)
        .then((missing) => {
            return missing.data;
        })
        .catch((error) => {
            return error.response.data;
        });
function* doAddMissing(payload) {
    try {
        let token = yield select(getToken);
        const missing = yield call(addMissingRequest, token, payload);

        if (missing.errorMessage) {
            ShowSmallError(missing.errorMessage);
            yield put(hideMissionLoader());
        } else {
            yield put(AddMissionSuccess(missing.data));
            TimerClsoe("آگهی ثبت شد", "در حال انتقال به درگاه");
        }
    } catch (error) {
        yield put(showMissionMessage(error));
    }
}

export function* addMissing() {
    yield takeEvery(ON_ADD_Missing, doAddMissing);
}
export default function* rootSaga() {
    yield all([
        fork(getMissingUser),
        fork(addMissing)]);
}
